/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Material_Not_Count_LoggedInputs */

const vi_error_material_not_count_logged = /** @type {(inputs: Error_Material_Not_Count_LoggedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có vật tư chưa bật "Kiểm bằng sổ kiểm túi". Vào Kho bao bì → Vật tư, bật cho vật tư đó rồi chọn lại.`)
};

/**

* @param {Error_Material_Not_Count_LoggedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_material_not_count_logged = /** @type {((inputs?: Error_Material_Not_Count_LoggedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Material_Not_Count_LoggedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_material_not_count_logged(inputs)
});